module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/_layout/mobilesidebar/mobilesidebar.component.css
// module id = ./src/app/_layout/mobilesidebar/mobilesidebar.component.css
// module chunks = main